<template>
  <div class="flex flex-col items-center justify-center h-screen bg-ontick-carbon-500">
    <h1 class="text-9xl font-bold mb-4 text-ontick-steel-400">404</h1>
    <p class="text-xl text-gray-400">Página não encontrada.</p>
  </div>
</template>

<script>
export default {
  name: "NotFound",

  beforeCreate() {
    this.$router.replace({ name: "Dashboard" }); // Redireciona para Dashboard
  },
};
</script>

<style lang="scss" scoped></style>
